import Error404 from "../pages/Errors/Error404.vue";
import Error403 from "../pages/Errors/Error403";

import Login from "../pages/Login";
import LoginConfirmation from "@/pages/LoginConfirmation.vue";
import Profile from "../pages/Profile";

import BaseLayout from "../layout/base/BaseLayout";
import DashboardLayout from "../layout/dashboard/DashboardLayout";
import Dashboard from "../pages/Dashboard";

import RequestsList from "../pages/AppPages/Requests/RequestsList";


import store from "../store";
import RequestDetail from "../pages/AppPages/Requests/RequestDetail";
import AnimalsList from "../pages/AppPages/Animals/AnimalsList";
import BaseRequest from "../pages/AppPages/Requests/BaseRequest";
import BaseAnimal from "../pages/AppPages/Animals/BaseAnimal";
import AnimalDetail from "../pages/AppPages/Animals/AnimalDetail";
import BaseCatalog from "../pages/AppPages/Catalogs/BaseCatalog";
import CommonEventList from "../pages/AppPages/Events/CommonEventList";
import EventDetail from "../pages/AppPages/Events/EventDetail";
import MunicipalityList from "../pages/AppPages/Catalogs/Municipality/MunicipalityList";
import MunicipalityDetail from "../pages/AppPages/Catalogs/Municipality/MunicipalityDetail";
import ContractList from "../pages/AppPages/Catalogs/Contracts/ContractList";
import ContractDetail from "../pages/AppPages/Catalogs/Contracts/ContractDetail";
import OrganizationList from "@/pages/AppPages/Catalogs/Organizations/OrganizationList";
import OrganizationDetail from "@/pages/AppPages/Catalogs/Organizations/OrganizationDetail";
import BreedList from "@/pages/AppPages/Catalogs/Animals/BreedList";
import BreedDetail from "@/pages/AppPages/Catalogs/Animals/BreedDetail";
import HabitatBulkCreate from "@/pages/AppPages/Events/Disposal/HabitatBulkCreate";
import RaidCatchingBulkCreate from "@/pages/AppPages/Events/Catching/RaidCatchingBulkCreate.vue";
import RequestCatchingBulkCreate from "@/pages/AppPages/Events/Catching/RequestCatchingBulkCreate.vue";
import EuthanasiaReasonList from "@/pages/AppPages/Catalogs/EuthanasiaReasons/EuthanasiaReasonList.vue";
import EuthanasiaReasonDetail from "@/pages/AppPages/Catalogs/EuthanasiaReasons/EuthanasiaReasonDetail.vue";
import RaidMonitoringBulkCreate from "@/pages/AppPages/Events/Catching/RaidMonitoringBulkCreate.vue";
import RequestMonitoringBulkCreate from "@/pages/AppPages/Events/Catching/RequestMonitoringBulkCreate.vue";
import Statistics from "@/pages/Statistics/Statistics.vue";
import EmptyLayout from "@/layout/base/EmptyLayout.vue";
import BaseNews from "@/pages/AppPages/News/BaseNews.vue";
import NewsList from "@/pages/AppPages/News/NewsList.vue";
import NewsDetail from "@/pages/AppPages/News/NewsDetail.vue";
import BaseFAQ from "@/pages/AppPages/Catalogs/FAQ/BaseFAQ.vue";
import QuestionList from "@/pages/AppPages/Catalogs/FAQ/QuestionList.vue";
import QuestionDetail from "@/pages/AppPages/Catalogs/FAQ/QuestionDetail.vue";
import QuestionGroupList from "@/pages/AppPages/Catalogs/FAQ/QuestionGroupList.vue";
import QuestionGroupDetail from "@/pages/AppPages/Catalogs/FAQ/QuestionGroupDetail.vue";



function getRoutes() {
    return [
        {
            path: "/",
            component: DashboardLayout,
            redirect: "/dashboard",
            props: {
                links: store.getters.menu,
            },
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: Dashboard,
                    meta: {
                        authenticationRequired: true,
                        title: 'Главная',
                    }
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: Profile,
                    meta: {
                        authenticationRequired: true,
                        title: 'Профиль',
                        bcName: 'profile',
                    }
                },
                {
                    path: "/statistics",
                    name: "statistics",
                    component: Statistics,
                    meta: {
                        authenticationRequired: true,
                        title: 'Аналитика',
                        bcName: 'statistics',
                    }
                },
                {
                    path: "requests",
                    component: BaseRequest,
                    meta: {
                        authenticationRequired: true,
                        title: 'Заявки',
                        bcName: 'requestsList'
                    },
                    children: [
                        {
                            path: "",
                            name: "requestsList",
                            component: RequestsList,
                            meta: {
                                authenticationRequired: true,
                            }
                        },
                        {
                            path: "create",
                            name: "requestCreate",
                            component: RequestDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Новая заявка',
                                bcName: 'requestCreate'
                            }
                        },
                        {
                            path: "raids/:raidId/catching/",
                                name: "raidCatchingCreate",
                                component: RaidCatchingBulkCreate,
                                props: true,
                                meta: {
                                    authenticationRequired: true,
                                    title: 'Новые мероприятия по отлову',
                                    bcName: 'raidCatchingCreate'
                                }
                        },
                        {
                            path: "raids/:raidId/release/",
                            name: "raidReleaseCreate",
                            component: HabitatBulkCreate,
                            props: true,
                            meta: {
                                authenticationRequired: true,
                                title: 'Новые мероприятия по выпуску',
                                bcName: 'raidReleaseCreate'
                            }
                        },
                        {
                            path: "raids/:raidId/monitoring/",
                            name: "raidMonitoringCreate",
                            component: RaidMonitoringBulkCreate,
                            props: true,
                            meta: {
                                authenticationRequired: true,
                                title: 'Новые мероприятия по отлову в результате мониторинга',
                                bcName: 'raidMonitoringCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseRequest,
                            meta: {
                                title: 'Карточка заявки',
                                bcName: 'requestsDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "requestsDetail",
                                    component: RequestDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                },
                                {
                                    path: "catching/",
                                    name: "requestCatchingCreate",
                                    component: RequestCatchingBulkCreate,
                                    props: true,
                                    meta: {
                                        authenticationRequired: true,
                                        title: 'Новые мероприятия по отлову',
                                        bcName: 'requestCatchingCreate'
                                    }
                                },
                                {
                                    path: "monitoring/",
                                    name: "requestMonitoringCreate",
                                    component: RequestMonitoringBulkCreate,
                                    props: true,
                                    meta: {
                                        authenticationRequired: true,
                                        title: 'Новые мероприятия по отлову в результате мониторинга',
                                        bcName: 'requestMonitoringCreate'
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "animals",
                    component: BaseAnimal,
                    meta: {
                        title: 'Животные',
                        bcName: 'animalsList'
                    },
                    children: [
                        {
                            path: "",
                            component: AnimalsList,
                            name: "animalsList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Животные',
                            }
                        },
                        {
                            path: "create/",
                            name: "animalCreate",
                            component: AnimalDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание карточки животного',
                                bcName: 'animalCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseAnimal,
                            meta: {
                                title: 'Карточка животного',
                                bcName: 'animalDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "animalDetail",
                                    component: AnimalDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]

                        },

                    ]
                },
                {
                    path: "events",
                    component: BaseCatalog,
                    meta: {
                        title: 'Мероприятия',
                        bcName: 'eventList'
                    },
                    children: [
                        {
                            path: "",
                            component: CommonEventList,
                            name: "eventList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Мероприятия',
                            }
                        },
                        {
                            path: "create/:kind/animal/:animalId",
                            name: "eventCreate",
                            component: EventDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание карточки мероприятия',
                                bcName: 'eventCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseCatalog,
                            meta: {
                                title: 'Карточка мероприятия',
                                bcName: 'eventDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "eventDetail",
                                    component: EventDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]

                        },
                    ]
                },
                {
                    path: "municipalities",
                    component: BaseCatalog,
                    meta: {
                        title: 'Муниципалитеты',
                        bcName: 'municipalityList'
                    },
                    children: [
                        {
                            path: "",
                            component: MunicipalityList,
                            name: "municipalityList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Муниципалитеты',
                            }
                        },
                        {
                            path: "create/",
                            name: "municipalityCreate",
                            component: MunicipalityDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание карточки муниципалитета',
                                bcName: 'municipalityCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseCatalog,
                            meta: {
                                title: 'Карточка муниципалитета',
                                bcName: 'municipalityDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "municipalityDetail",
                                    component: MunicipalityDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]

                        },
                    ]
                },
                {
                    path: "contracts",
                    component: BaseCatalog,
                    meta: {
                        title: 'Контракты',
                        bcName: 'contractList'
                    },
                    children: [
                        {
                            path: "",
                            component: ContractList,
                            name: "contractList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Контракты',
                            }
                        },
                        {
                            path: "create/",
                            name: "contractCreate",
                            component: ContractDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание карточки контракта',
                                bcName: 'contractCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseCatalog,
                            meta: {
                                title: 'Карточка контракта',
                                bcName: 'contractDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "contractDetail",
                                    component: ContractDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]

                        },
                    ]
                },
                {
                    path: "organizations",
                    component: BaseCatalog,
                    meta: {
                        title: 'Организации',
                        bcName: 'organizationList',
                    },
                    children: [
                        {
                            path: '',
                            component: OrganizationList,
                            name: "organizationList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Организации',
                            },
                        },
                        {
                            path: "create/",
                            component: OrganizationDetail,
                            name: "organizationCreate",
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание',
                                bcName: 'municipalOrganizationCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseCatalog,
                            meta: {
                                title: 'Карточка организации',
                                bcName: ''
                            },
                            children: [
                                {
                                    path: "",
                                    name: "organizationDetail",
                                    component: OrganizationDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]
                        }
                    ]

                },
                {
                    path: "breeds",
                    component: BaseCatalog,
                    meta: {
                        title: 'Виды и породы',
                        bcName: 'breedList'
                    },
                    children: [
                        {
                            path: "",
                            component: BreedList,
                            name: "breedList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Виды и породы',
                            }
                        },
                        {
                            path: "create/",
                            name: "breedCreate",
                            component: BreedDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание карточки породы',
                                bcName: 'breedCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseCatalog,
                            meta: {
                                title: 'Карточка породы',
                                bcName: 'breedDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "breedDetail",
                                    component: BreedDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]

                        },
                    ]
                },
                {
                    path: "euthanasia-reasons",
                    component: BaseCatalog,
                    meta: {
                        title: 'Основание для эвтаназии',
                        bcName: 'euthanasiaReasonList'
                    },
                    children: [
                        {
                            path: "",
                            component: EuthanasiaReasonList,
                            name: "euthanasiaReasonList",
                            meta: {
                                authenticationRequired: true,
                                title: 'Основание для эвтаназии',
                            }
                        },
                        {
                            path: "create/",
                            name: "euthanasiaReasonCreate",
                            component: EuthanasiaReasonDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Создание карточки основания для эвтаназии',
                                bcName: 'euthanasiaReasonCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseCatalog,
                            meta: {
                                title: 'Карточка основания для эвтаназии',
                                bcName: 'euthanasiaReasonDetail'
                            },
                            children: [
                                {
                                    path: "",
                                    name: "euthanasiaReasonDetail",
                                    component: EuthanasiaReasonDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]

                        },
                    ]
                },
                {
                    path: "news",
                    component: BaseNews,
                    meta: {
                        authenticationRequired: true,
                        title: 'Новости',
                        bcName: 'newsList'
                    },
                    children: [
                        {
                            path: "",
                            name: "newsList",
                            component: NewsList,
                            meta: {
                                authenticationRequired: true,
                            }
                        },
                        {
                            path: "create",
                            name: "newsCreate",
                            component: NewsDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Новая новость',
                                bcName: 'newsCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseNews,
                            meta: {
                                title: 'Карточка новости',
                                bcName: 'newsDetail'
                            },
                               children: [
                                {
                                    path: "",
                                    name: "newsDetail",
                                    component: NewsDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "questions",
                    component: BaseFAQ,
                    meta: {
                        authenticationRequired: true,
                        title: 'Информационные материалы',
                        bcName: 'questionsList'
                    },
                    children: [
                        {
                            path: "",
                            name: "questionsList",
                            component: QuestionList,
                            meta: {
                                authenticationRequired: true,
                            }
                        },
                        {
                            path: "create",
                            name: "questionCreate",
                            component: QuestionDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Новый информационный материал',
                                bcName: 'questionCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseFAQ,
                            meta: {
                                title: 'Карточка информационного материала',
                                bcName: 'questionDetail'
                            },
                               children: [
                                {
                                    path: "",
                                    name: "questionDetail",
                                    component: QuestionDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]
                        }
                    ]
                },

                {
                    path: "question-groups",
                    component: BaseFAQ,
                    meta: {
                        authenticationRequired: true,
                        title: 'Тематики',
                        bcName: 'questionGroupList'
                    },
                    children: [
                        {
                            path: "",
                            name: "questionGroupList",
                            component: QuestionGroupList,
                            meta: {
                                authenticationRequired: true,
                            }
                        },
                        {
                            path: "create",
                            name: "questionGroupCreate",
                            component: QuestionGroupDetail,
                            meta: {
                                authenticationRequired: true,
                                title: 'Новая тематика',
                                bcName: 'questionGroupCreate'
                            }
                        },
                        {
                            path: ":id/",
                            component: BaseFAQ,
                            meta: {
                                title: 'Карточка тематики',
                                bcName: 'questionGroupDetail'
                            },
                               children: [
                                {
                                    path: "",
                                    name: "questionGroupDetail",
                                    component: QuestionGroupDetail,
                                    meta: {
                                        authenticationRequired: true,
                                    },
                                }
                            ]
                        }
                    ]
                },
            ]
        },
        {
            path: "/login",
            component: BaseLayout,
            children: [
                {
                    path: "",
                    name: "login",
                    component: Login
                }
            ]
        },
        {
            path: "/login/confirm/",
            component: BaseLayout,
            children: [
                {
                    path: "",
                    name: "loginConfirmation",
                    component: LoginConfirmation,
                }
            ]
        },
        {
            path: "/forbidden",
            component: EmptyLayout,
            children: [
                {path: '', component: Error403}
            ]
        },
        {
            path: "*",
            component: EmptyLayout,
            children: [
                {path: '', component: Error404}
            ]
        }
    ]
}

export default getRoutes;
